import React from "react";

// v-minors 2026-06 — صيغة التقاطع المشتركة الوحيدة فوق العداد الحي:
// «معرّض للفقد ∩ نساء ∩ 25–35 = 18». تعيد استخدامها كل شاشات الإرسال.
export function demoTerms(demo = {}) {
  const parts = [];
  if (demo.gender === "male") parts.push("رجال");
  else if (demo.gender === "female") parts.push("نساء");
  else if (demo.gender === "unknown") parts.push("غير محدد الجنس");
  const hasMin = demo.age_min !== null && demo.age_min !== undefined && demo.age_min !== "";
  const hasMax = demo.age_max !== null && demo.age_max !== undefined && demo.age_max !== "";
  if (hasMin || hasMax) {
    parts.push(`${hasMin ? demo.age_min : "0"}–${hasMax ? demo.age_max : "∞"}`);
  }
  return parts;
}

export function AudienceFormula({ segmentLabel, demo = {}, count, testid = "audience-formula" }) {
  const terms = [segmentLabel || "الكل", ...demoTerms(demo)];
  const n = Number(count || 0).toLocaleString("en-US");
  return (
    <div data-testid={testid}
         className="rounded-lg px-3 py-2 mb-2 text-sm font-bold"
         style={{ background: "#F5F3FF", color: "#5B21B6", border: "1px solid #C4B5FD" }}>
      {terms.join(" ∩ ")} = <span data-testid={`${testid}-count`}>{n}</span>
    </div>
  );
}

export default AudienceFormula;
